import { CommonModule, formatDate } from '@angular/common';
import { Component, inject, input, OnChanges, signal, SimpleChanges, viewChild } from '@angular/core';
import { ModalCertificationComponent } from './modal-certification/modal-certification.component';
import { ResumeCertification } from 'src/app/models/resume/resume';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cv-certifications',
  imports: [CommonModule, ModalCertificationComponent],
  templateUrl: './cv-certifications.component.html',
  styleUrl: './cv-certifications.component.css'
})
export class CvCertificationsComponent implements OnChanges {
  public resumeId = input<number | null>(null);
  certifications = signal<ResumeCertification[]>([]);

  private readonly resumeService = inject(ResumeService);

  indexResume = signal<number | null>(null);

  modalCertificationComponent = viewChild(ModalCertificationComponent);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resumeId']?.currentValue) {
      this.getResumeCertifications();
    }
  }

  getResumeCertifications() {
    const resumeId = this.resumeId();
    if (!resumeId) {
      return;
    }
    this.resumeService.getResumeCertifications(resumeId).subscribe({
      next: res => {
        this.certifications.set(res);
      }
    });
  }

  add() {
    this.indexResume.set(null);
    if (this.modalCertificationComponent()) {
      this.modalCertificationComponent()?.reset();
    }
  }

  editResumeCertification(resumeCertification: ResumeCertification, index: number) {
    this.indexResume.set(index);
    if (this.modalCertificationComponent()) {
      this.modalCertificationComponent()?.form.patchValue({
        ...resumeCertification as any,
        completionDate: formatDate(resumeCertification.completionDate, 'yyyy-MM-dd', 'en'),
        expirationDate: resumeCertification.expirationDate ? formatDate(resumeCertification.expirationDate, 'yyyy-MM-dd', 'en') : null
      });
    }
  }

  deleteResumeCertification(resumeCertification: ResumeCertification, index: number) {
    const resumeId = this.resumeId();
    const id = resumeCertification.id ?? 0;

    if (!resumeId) {
      this.certifications.update(value => value?.filter((certification, i) => i !== index));
      return;
    }

    Swal.fire({
      title: 'Eliminar',
      text: '¿Desea eliminar este registro?',
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: '#0d1174',
      cancelButtonColor: '#3a3a3a',
      confirmButtonText: 'Eliminar'
    }).then((resultmodal) => {
      if (resultmodal.isConfirmed) {
        this.resumeService.deleteResumeCertification(id).subscribe({
          next: res => {
            this.certifications.update(certifications => certifications.filter(certification => certification.id !== id));
          }, error: res => {
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error al eliminar el registro.',
              icon: 'error',
              confirmButtonColor: '#d33'
            });
          }
        })
      }
    });
  }

  handlerResumeCertification(resumeCertification: ResumeCertification) {
    const resumeId = this.resumeId();
    if (resumeId) {
      this.getResumeCertifications();
      return;
    }
    if (this.indexResume() != null || resumeCertification.id) {
      this.certifications.update(value => value?.map((certification, i) => {
        if (i === this.indexResume() || certification.id === resumeCertification.id) {
          return resumeCertification
        }
        return certification;
      }));
      return;
    }
    this.certifications.set([...this.certifications(), resumeCertification]);
  }
}
